import React, { useState } from 'react';
import LinkCreditReport from '../components/modal/LinkCreditReportModal';

const LinkCreditReportButton = props => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <LinkCreditReport {...props}>
      <a 
        className="p-2" 
        data-dismiss='modal'
        style={{ 
          color: '#ffc03a',
          cursor: isHovered ? 'pointer' : 'default'
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        Link Weimark Credit Report
      </a>
    </LinkCreditReport>
  );
};

export default LinkCreditReportButton;
